/* eslint-disable no-unused-vars */
import React from "react";
import heroImage from "../assets/kisangImage.png";
import { HiArrowRight } from "react-icons/hi";
import { Link } from "react-scroll";

const Hero = () => {
  return (
    <div
      name="hero"
      className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800 pt-20"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full">
          <h2 className="text-4xl md:text-7xl text-white font-bold">
            I am a Full Stack Developer
          </h2>
          <p className="text-gray-500 max-w-md py-4">
            Over the past 5 years, I have embarked on an exhilarating journey
            through the ever-evolving landscape of web development, leveraging
            cutting-edge technologies to create immersive digital experiences.
            My toolkit has been anchored by React.js for frontend development,
            Express.js and Node.js for backend architecture, MongoDB for robust
            database management, and Tailwind CSS for streamlined styling. Let
            me take you through the milestones of this transformative journey.
          </p>
          <div>
            <Link
              to="projects"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-2 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <HiArrowRight size={15} className="ml-5" />
              </span>
            </Link>
          </div>
        </div>
        <div>
          <img
            src={heroImage}
            alt="my pp"
            className="rounded-md mx-auto w-2/3 md:w-full hover:rounded-full cursor-pointer duration-500"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
